import type { CareerContent, JobOpening } from "@/services/api";

export const EMPLOYMENT_TYPES = [
  "Full-time",
  "Part-time",
  "Contract",
  "Temporary",
  "Internship",
] as const;

export const WORK_MODES = ["On-site", "Hybrid", "Remote"] as const;

export const EXPERIENCE_LEVELS = [
  "Entry",
  "Mid",
  "Senior",
  "Lead",
  "Executive",
] as const;

export const JOB_STATUSES = ["Open", "Closed", "Draft"] as const;

export function emptyJobOpening(): JobOpening {
  return {
    id: `job-${Date.now()}`,
    jobCode: "",
    title: "",
    department: "",
    employmentType: "Full-time",
    workMode: "On-site",
    location: "Sugar Land, TX",
    experienceLevel: "Mid",
    experienceYears: "",
    education: "",
    summary: "",
    responsibilities: "",
    requirements: "",
    preferredQualifications: "",
    benefits: "",
    salaryRange: "",
    openings: 1,
    applyEmail: "careers@kavispharma.com",
    applyUrl: "",
    postedDate: new Date().toISOString().slice(0, 10),
    closingDate: "",
    status: "Draft",
    isFeatured: false,
  };
}

export const defaultCareerContent: CareerContent = {
  hero: {
    title: "We Passionately Pursue Life-Improving Opportunities",
    description:
      "Kavis Pharma helps advance healthcare through the work our people deliver. We strive to move health forward and make life easier.",
    buttonText: "Know More",
    buttonLink: "/about",
    backgroundImage:
      "https://kavispharma.com/wp-content/uploads/2024/06/bg.jpeg",
  },
  growth: {
    title: "Grow Your Career With Kavis Pharma",
    description:
      "We are dedicated to fostering a professional environment where you don't just have the opportunity to utilize your skills, you can grow your career by leaps and bounds.",
    cards: [
      {
        icon: "ri-headphone-line",
        text: "We firmly believe that creating a supportive work environment is essential for our people to reach their full potential.",
      },
      {
        icon: "ri-team-line",
        text: "We firmly believe that creating a supportive work environment is essential for our people to reach their full potential.",
      },
    ],
  },
  contactCta: {
    title: "Contact Us Here For More Opportunities And Information",
    subtitle: "If you need to converse more, we understand",
    buttonText: "CONTACT US",
    buttonLink: "/contact",
  },
  jobBoard: {
    title: "Our Current Job Openings",
    description:
      "Thank you for visiting our job board. Please click on a job title to view the requirements for that particular job. You can apply directly from within the job ad.",
    emptyMessage:
      "There are no open positions at the moment. Please check back soon or contact us for future opportunities.",
    jobs: [],
  },
  diversity: {
    title: "Join Us In Shaping A Democratic And Inclusive Future.",
    description:
      "Our commitment extends to creating an inclusive workplace that values diversity. We believe in a progressive, socially-responsible, and open-minded company culture where factors such as gender, religion, political orientation, sexual preferences, and skin color do not influence your experience at Kavis.",
  },
  bottomImage: {
    imageUrl:
      "https://kavispharma.com/wp-content/uploads/2024/06/career-bg.jpeg",
  },
};
